"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_NEXT_CHALLENGE_UNKNOWN = exports.MOCK_NEXT_CHALLENGE_NONE = exports.MOCK_NEXT_CHALLENGE_SIGNATURE_KEY = exports.MOCK_NEXT_CHALLENGE_TRUSTED_LOGIN = exports.MOCK_NEXT_CHALLENGE_TRUSTED = exports.MOCK_NEXT_CHALLENGE_OTP_LOGIN = exports.MOCK_NEXT_CHALLENGE_OTP_IVR = exports.MOCK_NEXT_CHALLENGE_OTP = void 0;
exports.MOCK_NEXT_CHALLENGE_OTP = {
    nextChallengeType: 'OTP',
    progressId: '31542466',
    otpId: '2673',
};
exports.MOCK_NEXT_CHALLENGE_OTP_IVR = {
    progressId: '71I2p5dSa0N5i+Q2lc63xTRnv4pRTogZv6zJXg2OPxM=',
    nextChallengeType: 'OTP',
    otpId: 'someid',
    additionalParameters: {
        channel: 'IVR',
    },
};
exports.MOCK_NEXT_CHALLENGE_OTP_LOGIN = {
    nextChallengeType: 'OTP_LOGIN',
    progressId: '31542466',
    otpId: '8374',
};
exports.MOCK_NEXT_CHALLENGE_TRUSTED = {
    nextChallengeType: 'BIOMETRIC_TRUSTED_CONFIRMATION',
    progressId: '31542466',
    biometricId: '82bzdcrw5ned',
};
exports.MOCK_NEXT_CHALLENGE_TRUSTED_LOGIN = {
    nextChallengeType: 'BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN',
    progressId: '31542466',
    biometricId: '82bzdcrw5ned',
    accessToken: '',
};
exports.MOCK_NEXT_CHALLENGE_SIGNATURE_KEY = {
    nextChallengeType: 'SIGNATURE_KEY',
    progressId: '31542466',
    signatureKeyPositions: ['2', '3', '5', '6'],
};
exports.MOCK_NEXT_CHALLENGE_NONE = {
    nextChallengeType: 'None',
    progressId: '31542466',
};
exports.MOCK_NEXT_CHALLENGE_UNKNOWN = {
    nextChallengeType: 'UNKNOWN',
    progressId: '5',
};
//# sourceMappingURL=nextChallengeMocks.js.map